import { Outlet, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getProperyFileDetails } from 'store/slices/properties';

export const PropertyLayout = () => {
  const dispatch = useDispatch();

  const { id: propertyId } = useParams();

  useEffect(() => {
    dispatch(getProperyFileDetails(propertyId));
  }, [dispatch, propertyId]);

  return <Outlet />;
};
